/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ApiResponseAgentGroup } from '../models/api-response-agent-group';
import { ApiResponseAgentGroupDetails } from '../models/api-response-agent-group-details';
import { ApiResponseListAgentGroup } from '../models/api-response-list-agent-group';
import { ApiResponsePagedResultAgentGroup } from '../models/api-response-paged-result-agent-group';
import { createAgentGroup } from '../fn/agent-group-api/create-agent-group';
import { CreateAgentGroup$Params } from '../fn/agent-group-api/create-agent-group';
import { deleteAgentGroup } from '../fn/agent-group-api/delete-agent-group';
import { DeleteAgentGroup$Params } from '../fn/agent-group-api/delete-agent-group';
import { getAgentGroupByRef } from '../fn/agent-group-api/get-agent-group-by-ref';
import { GetAgentGroupByRef$Params } from '../fn/agent-group-api/get-agent-group-by-ref';
import { getListAgentGroup } from '../fn/agent-group-api/get-list-agent-group';
import { GetListAgentGroup$Params } from '../fn/agent-group-api/get-list-agent-group';
import { searchAgentGroup } from '../fn/agent-group-api/search-agent-group';
import { SearchAgentGroup$Params } from '../fn/agent-group-api/search-agent-group';
import { updateAgentGroup } from '../fn/agent-group-api/update-agent-group';
import { UpdateAgentGroup$Params } from '../fn/agent-group-api/update-agent-group';
import { updateArchiveStatus1 } from '../fn/agent-group-api/update-archive-status-1';
import { UpdateArchiveStatus1$Params } from '../fn/agent-group-api/update-archive-status-1';

@Injectable({ providedIn: 'root' })
export class AgentGroupApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getAgentGroupByRef()` */
  static readonly GetAgentGroupByRefPath = '/v1/api/ui/agent-group/{ref}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAgentGroupByRef()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAgentGroupByRef$Response(params: GetAgentGroupByRef$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseAgentGroupDetails>> {
    return getAgentGroupByRef(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAgentGroupByRef$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAgentGroupByRef(params: GetAgentGroupByRef$Params, context?: HttpContext): Observable<ApiResponseAgentGroupDetails> {
    return this.getAgentGroupByRef$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseAgentGroupDetails>): ApiResponseAgentGroupDetails => r.body)
    );
  }

  /** Path part for operation `updateAgentGroup()` */
  static readonly UpdateAgentGroupPath = '/v1/api/ui/agent-group/{ref}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateAgentGroup()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateAgentGroup$Response(params: UpdateAgentGroup$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseAgentGroup>> {
    return updateAgentGroup(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateAgentGroup$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateAgentGroup(params: UpdateAgentGroup$Params, context?: HttpContext): Observable<ApiResponseAgentGroup> {
    return this.updateAgentGroup$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseAgentGroup>): ApiResponseAgentGroup => r.body)
    );
  }

  /** Path part for operation `deleteAgentGroup()` */
  static readonly DeleteAgentGroupPath = '/v1/api/ui/agent-group/{ref}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteAgentGroup()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteAgentGroup$Response(params: DeleteAgentGroup$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteAgentGroup(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteAgentGroup$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteAgentGroup(params: DeleteAgentGroup$Params, context?: HttpContext): Observable<void> {
    return this.deleteAgentGroup$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `createAgentGroup()` */
  static readonly CreateAgentGroupPath = '/v1/api/ui/agent-group';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createAgentGroup()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createAgentGroup$Response(params: CreateAgentGroup$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseAgentGroup>> {
    return createAgentGroup(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createAgentGroup$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createAgentGroup(params: CreateAgentGroup$Params, context?: HttpContext): Observable<ApiResponseAgentGroup> {
    return this.createAgentGroup$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseAgentGroup>): ApiResponseAgentGroup => r.body)
    );
  }

  /** Path part for operation `searchAgentGroup()` */
  static readonly SearchAgentGroupPath = '/v1/api/ui/agent-group/search';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchAgentGroup()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchAgentGroup$Response(params: SearchAgentGroup$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponsePagedResultAgentGroup>> {
    return searchAgentGroup(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchAgentGroup$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchAgentGroup(params: SearchAgentGroup$Params, context?: HttpContext): Observable<ApiResponsePagedResultAgentGroup> {
    return this.searchAgentGroup$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponsePagedResultAgentGroup>): ApiResponsePagedResultAgentGroup => r.body)
    );
  }

  /** Path part for operation `getListAgentGroup()` */
  static readonly GetListAgentGroupPath = '/v1/api/ui/agent-group/list';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getListAgentGroup()` instead.
   *
   * This method doesn't expect any request body.
   */
  getListAgentGroup$Response(params: GetListAgentGroup$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseListAgentGroup>> {
    return getListAgentGroup(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getListAgentGroup$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getListAgentGroup(params: GetListAgentGroup$Params, context?: HttpContext): Observable<ApiResponseListAgentGroup> {
    return this.getListAgentGroup$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseListAgentGroup>): ApiResponseListAgentGroup => r.body)
    );
  }

  /** Path part for operation `updateArchiveStatus1()` */
  static readonly UpdateArchiveStatus1Path = '/v1/api/ui/agent-group/archive/{ref}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateArchiveStatus1()` instead.
   *
   * This method doesn't expect any request body.
   */
  updateArchiveStatus1$Response(params: UpdateArchiveStatus1$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateArchiveStatus1(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateArchiveStatus1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  updateArchiveStatus1(params: UpdateArchiveStatus1$Params, context?: HttpContext): Observable<void> {
    return this.updateArchiveStatus1$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
